import React from "react";
import Layout from "../../components/shared/Layout/Layout";
import HomeworkPerformanceViewResults from "../../components/HomeworkPerformanceViewResults/HomeworkPerformanceViewResults";

const ViewHomeworkPerformancePage = () => {
  return (
    <div
      className="bg_dark"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <Layout title={`View Homework Performance`}>
        <HomeworkPerformanceViewResults />
      </Layout>
    </div>
  );
};

export default ViewHomeworkPerformancePage;
